<template><div><h1 id="kostenstellen" tabindex="-1"><a class="header-anchor" href="#kostenstellen"><span>Kostenstellen</span></a></h1>
<p>Kostenstellen — Definiert Kostenstellen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Tabelle Kostenstellen dient der Überprüfung der Dateneingabe und Fakturierung, indem hier sämtliche gültigen Kostenstellen eingegeben werden müssen. Das System überwacht dann automatisch die Buchungen für die Schnittstelle Finanzbuchhaltung, indem es das Vorhandensein der Kostenstelle überprüft und validiert.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → Kontenplan</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Kostenstelle</dt>
<dd>Kostenstelle</dd>
<dt>Export-Kst</dt>
<dd>Ersatz-Kostenstelle für Export</dd>
<dt>Bezeichnung</dt>
<dd>Kostenstellen-Bezeichnung</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.kontkomb.html" title="Kontenplan">Kontenplan</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.konti.html" title="Konti">Konti</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.ktr.html" title="Kostenträger">Kostenträger</RouteLink></p>
</div></template>


